module.exports = __webpack_public_path__ + "static/media/logob.0caa27f4.png";